import React, { useEffect, useState } from 'react';
import { Card, Spin, Tag, Row, Col, List } from 'antd';
import reqwest from 'reqwest';
import moment from 'moment';
import { getToken, formatDoseByUnit } from '../../Utils/common';
import config from '../../config';

function MedicalSchemaHistory({ medicalSchemaId }) {
  const [loadingMedHist, setLoadingMedHist] = useState(false);
  const [medHist, setMedHist] = useState([]);

  const canLoad = !!medicalSchemaId;

  const fetchMedicationHistory = () => {
    if (!medicalSchemaId) return;
    setLoadingMedHist(true);
    reqwest({
      url: `${config.api_url}/medicalschemamedicationhistory/?medical_schema=${medicalSchemaId}`,
      method: 'get',
      type: 'json',
      headers: { 'Authorization': `Token ${getToken()}` },
    }).then(response => {
      const results = Array.isArray(response) ? response : (response.results || []);
      setMedHist(results);
      setLoadingMedHist(false);
    }).catch(error => {
      setLoadingMedHist(false);
      if (error.status === 401) {
        sessionStorage.removeItem('token');
        sessionStorage.removeItem('user');
        window.location.href = '/login';
      }
    });
  };

  useEffect(() => {
    fetchMedicationHistory();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [medicalSchemaId]);


  return (
    <div>
      <Row gutter={16}>
        <Col span={24}>
          <Card title="Historial de Medicamentos">
            <Spin spinning={loadingMedHist}>
              {!canLoad && <div style={{ marginBottom: 12, color: '#999' }}>Seleccione una internación para ver el historial.</div>}
              {canLoad && (
                medHist.length === 0 ? (
                  <div style={{ color: '#999' }}>Sin movimientos.</div>
                ) : (
                  <List
                    itemLayout="horizontal"
                    dataSource={medHist}
                    renderItem={(item) => {
                      let color = 'default';
                      let label = item.action;
                      switch (item.action) {
                        case 'ADD':
                          color = 'green';
                          label = 'Agregado';
                          break;
                        case 'DEL':
                          color = 'red';
                          label = 'Eliminado';
                          break;
                        case 'UPD':
                          color = 'blue';
                          label = 'Modificado';
                          break;
                        default:
                          color = 'default';
                          label = item.action;
                      }
                      return (
                        <List.Item key={item.id}>
                          <List.Item.Meta
                            title={
                              <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'center' }}>
                                <span style={{ color: '#555' }}>{moment(item.changed_at).format('DD/MM/YYYY HH:mm')}</span>
                                <Tag color={color}>{label}</Tag>
                                <span style={{ fontWeight: 500 }}>{item.medication_name}</span>
                                {(item.dose || item.unit) && (
                                  <span style={{ color: '#666' }}>— {(item.dose != null && item.dose !== '') ? formatDoseByUnit(item.dose, item.unit) : ''} {item.unit || ''}</span>
                                )}
                              </div>
                            }
                            description={<div style={{ color: '#888' }}>Por: {item.changed_by_username || '-'}</div>}
                          />
                        </List.Item>
                      );
                    }}
                  />
                )
              )}
            </Spin>
          </Card>
        </Col>
      </Row>
    </div>
  );
}

export default MedicalSchemaHistory;
